<template>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-w-full">
    <div class="tw-flex tw-flex-col tw-min-h-[50px] tw-justify-center">
      <a
        v-if="data.path === '/learn/help'"
        class="tw-truncate page-topic-title tw-cursor-pointer"
        href="https://help.cybersystem.io/"
        >{{ data.title }}</a
      >
      <a
        v-else-if="data.path === '/settings/subscription'"
        class="tw-truncate page-topic-title tw-cursor-pointer"
        @click="routerSubscription"
        >{{ data.title }}</a
      >
      <router-link
        v-else
        :to="
          data.path === '/assess/input'
            ? getLatestChecklistId !== undefined
              ? `${data.path}?checklistId=${getLatestChecklistId}`
              : '/assess/manage'
            : data.path
        "
        @click.stop="$emit('close-menu')"
      >
        <span class="tw-truncate page-topic-title">{{ data.title }}</span>
      </router-link>
      <span
        class="tw-truncate tw-whitespace-normal tw- page-topic-sub-description"
      >
        {{ data.description }}
      </span>
    </div>
    <a
      v-if="data.path === '/learn/help'"
      class="tw-truncate page-topic-title"
      href="https://help.cybersystem.io/"
      ><IconRight
    /></a>
    <a
      v-else-if="data.path === '/settings/subscription'"
      class="tw-truncate page-topic-title tw-cursor-pointer"
      @click="routerSubscription"
      ><div v-if="isLoadingStripURL" class="tw-h-[38px] tw-w-[38px]">
        <!-- eslint-disable vue/no-unused-refs -->
        <LottieAnimation
          ref="anim"
          :animation-data="ProgressAnimation"
          :auto-play="true"
          :loop="true"
        />
      </div>
      <IconRight v-else
    /></a>
    <router-link v-else :to="data.path">
      <IconRight />
    </router-link>
  </div>
</template>

<script setup lang="ts">
/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Subscription } from "@/services/apiRoutes/routes";
import { getSessionPortal } from "@/services/subscriptions";
import store from "@/store";
import { computed, ref } from "vue";
import ProgressAnimation from "../../../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";

const props = defineProps<{
  data: {
    title: string;
    path: string;
    description: string;
    checklistId?: string;
  };
}>();

const isLoadingStripURL = ref(false);

const getLatestChecklistId = computed(() => {
  return store.getters["Recommend/getLatestChecklistId"];
});

const routerSubscription = async () => {
  try {
    {
      isLoadingStripURL.value = true;
      const clientSecretResponse = await getSessionPortal("dashboard");
      const sessionPortalUrl =
        clientSecretResponse.data?.data?.redirectUrl || "";
      if (!sessionPortalUrl) {
        showErrorAPI("app-settings-subscription-error-text-1", "error");
        isLoadingStripURL.value = false;
        return;
      }
      window.location.href = sessionPortalUrl;
      setTimeout(() => {
        isLoadingStripURL.value = false;
      }, 1000);
      return;
    }
  } catch (error) {
    // showErrorAPI(error, Subscription.getSessionPortal);
  }
};

const emit = defineEmits<{
  (e: "close-menu"): void;
}>();
</script>

<style scoped>
.page-topic-title {
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #387dff;
  user-select: none;
}
.page-topic-sub-description {
  font-family: Poppins, sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #878787;
  user-select: none;
}
</style>
